// extracted by css-extract-rspack-plugin
export default {"container":"I65SNdpP_mk6qACg","header":"LYvrM5OuUDA6eI5E","blackText":"lRSyS0TcM68TcmUh"};